import {Button, ModalBody, ModalContent, ModalFooter, ModalHeader} from "@nextui-org/react";
import Lottie from "lottie-react";
import approved from "../../assets/approved.json";
import failed from "../../assets/failed.json";
import buy from "../../assets/buy_completed.wav";
import error from "../../assets/error.wav";
import React, {useEffect} from "react";

export const PayCompleted = ({data, Reseting}) => {

    useEffect(() => {
        playSound(data.status);
    }, []);

    const playSound = (status) =>{
        const audio = new Audio(status === "AP" ? buy : error);
        audio.play();
    }

    return (

        <ModalContent>
            <ModalHeader className="flex flex-col gap-1">El pago
                fue {data.status === "AP" ? "aprobado" : "rechazado"}.</ModalHeader>
            <ModalBody>
                <div className="loading-container">
                    <Lottie animationData={data.status === "AP" ? approved : failed} loop={false}/>
                </div>
            </ModalBody>
            <ModalFooter>{data.status === "AP" ? <b>Favor aguarde unos segundos..</b> :
                <Button className="bg-danger" variant="light" onPress={() => {
                    Reseting();
                }}>
                    Salir
                </Button>}</ModalFooter>
        </ModalContent>


    )
}